<template>
<v-container fluid class="pa-0">
    <v-toolbar class="elevation-1" height="48px">
        <v-toolbar-title >Gestion des contacts</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn rounded outlined depressed text @click="modalHelp = !modalHelp" color="primary" class="mr-2 white--text" v-on="on">
                    <v-icon dark>mdi-help-circle-outline</v-icon><span class="hidden-sm-and-down"></span>
                </v-btn>
            </template>
            <span>Comment importer des contacts</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn rounded outlined depressed text :color="(!withTrashed) ? 'grey' : 'red'" @click="withTrashed = !withTrashed; getContact()" class="mr-2 white--text" v-on="on">
                    <v-icon dark>mdi-delete-restore</v-icon><span class="hidden-sm-and-down"></span>
                </v-btn>
            </template>
            <span>Afficher les contacts supprimés</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn rounded outlined depressed text @click="modalUpload = true" color="orange" class="mr-2 white--text" v-on="on">
                    <v-icon dark>mdi-cloud-upload</v-icon><span class="hidden-sm-and-down"></span>
                </v-btn>
            </template>
            <span>Injecter / modifier des contacts</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn rounded outlined depressed text @click="downloadContact()" color="primary" class="mr-2 white--text" v-on="on">
                    <v-icon dark>mdi-file-excel</v-icon><span class="hidden-sm-and-down"></span>
                </v-btn>
            </template>
            <span>Télécharger la liste des contacts</span>
        </v-tooltip>
        <v-btn color="success" rounded depressed class="white--text" to="/contacts/0">
            <v-icon left dark>mdi-plus-circle</v-icon>
            <span class="hidden-sm-and-down">Créer</span>
        </v-btn>
    </v-toolbar>
    <v-text-field
        append-icon="mdi-magnify" label="Recherche" @blur="saveSearchToCache()"
        solo clearable single-line hide-details v-model="search" class="ma-4 pa-0">
    </v-text-field>
    <v-card class="ma-4">
    <v-data-table v-bind:headers="headers" :items="items" item-key="sta_id" :search="search"
        items-per-page-text="Lignes par page" :items-per-page-options="pagination.rowsPerItem">
        <template v-slot:[`item.ctt_middlename`]="{ item }">
            <div class="text-truncate" style="max-width: 400px;" :title="item.ctt_middlename">{{ item.ctt_middlename }}</div>
        </template>
        <template v-slot:[`item.ctt_company_name`]="{ item }">
            <div v-if="item.ctt_company_name" class="text-truncate" style="max-width: 300px;" :title="item.ctt_company_name">
                {{ item.ctt_company_name }}
            </div>
        </template>
        <template v-slot:[`item.ctt_sta_id`]="{ item }">
            <v-chip v-if="(item.ctt_deleted_at)" small outlined label color="red">Supprimé</v-chip>
            <v-chip v-else small outlined label :color="getCacheState('GEN', item.ctt_sta_id).typ_color">{{ getCacheState('GEN', item.ctt_sta_id).sta_label }}</v-chip>
        </template>
        <template v-slot:[`item.ctt_typ_id`]="{ item }">
            <v-chip small outlined label :color="getCacheType('CTT', item.ctt_typ_id).typ_color">{{ getCacheType('CTT', item.ctt_typ_id).typ_name }}</v-chip>
        </template>
        <template v-slot:[`item.ctt_phone`]="{ item }">
            <span class="caption text--primary font-italic">{{ formatPhoneNumber(item.ctt_phone) }}</span>
            <br />
            <span class="caption text--primary font-italic">{{ formatPhoneNumber(item.ctt_mobile) }}</span>
        </template>
        <template v-slot:[`item.ctt_email`]="{ item }">
            <v-chip v-if="item.ctt_email" small outlined label :title="item.ctt_email">
                {{ (item.ctt_email) ? item.ctt_email.substring(0, 22) : '' }}
                {{ (item.ctt_email && item.ctt_email.length > 21) ? '...' : '' }}
            </v-chip>
        </template>
        <template v-slot:[`item.ctt_updated_at`]="{ item }">
            <span class="caption text--primary font-italic">{{ locDateFormat.toLocale(item.ctt_updated_at, { year: 'numeric', month: 'long', day: 'numeric' }) }}</span>
        </template>
        <template v-slot:[`item.ctt_id`]="{ item }">
            <v-btn v-if="(!item.ctt_deleted_at)" outlined small color="grey" class="ml-2 elevation-1" :href="'/#/contacts/' + item.ctt_id + ''">
                <v-icon left class="mr-2">mdi-pencil</v-icon>Editer
            </v-btn>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        De {{ pageStart }} à {{ pageStop }}
        </template>
    </v-data-table>
    </v-card>

    <v-dialog v-model="modalUpload" max-width="900" >
        <v-card color="grey lighten-4" flat>
            <v-toolbar color="primary" dark class="elevation-2" height="50px">
                <v-icon class="mr-3">mdi-chevron-down</v-icon>
                <v-toolbar-title>Importer des contacts</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon color="" @click.native="modalUpload = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout row wrap>
                <v-flex xs6 class="pa-2">
                    <v-file-input ref="contact" color="orange"
                        @change="getFile($event, 'contact')" label="Selectionner un fichier"
                        v-model="form.file_contact">
                    </v-file-input>
                </v-flex>
                <v-flex xs4 class="pa-2">
                    <v-select 
                        item-text="typ_name" item-value="typ_id"
                        :items="getCacheType('CTT')" v-model="form.ctt_typ_id" label="Type" single-line >
                    </v-select>
                </v-flex>
                <v-flex xs2 class="pa-2">
                    <v-btn color="green" class="mt-3" @click="sendContactFile('contact')" :disabled="(!validUplodContact || saveProgress)">Envoyer</v-btn>
                </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>
    <!-- Tuto -->
    <v-dialog v-model="modalHelp" max-width="1000" persistent>
        <v-card>
            <v-toolbar dark color="primary" dense flat>
                <v-toolbar-title class="white--text">Importer / modifier des contacts</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="" outlined @click="modalHelp = !modalHelp"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="4" class="pa-2 pr-2 topline">
                        <v-img width="325" :src="tuto.zip"></v-img>
                    </v-col>
                    <v-col cols="8" class="pa-2 pr-2 topline">
                        <v-alert outlined type="success" prominent border="left">
                            Pour modifier des contacts vous pouvez commecner par télécharger lkla liste existante en cliquant sur le bouton "Télécharger la liste des contacts".
                        </v-alert>
                    </v-col>
                    <v-col cols="4" class="pa-2 pr-2 topline">
                        <v-img width="325" :src="tuto.edit"></v-img>
                    </v-col>
                    <v-col cols="8" class="pa-2 pr-2 topline">
                        <v-alert outlined type="success" prominent border="left">
                            Vous pouvez ensuite modifier le fichier Excel téléchargé, ajouter des contacts ou modifier des contacts existants.
                            <br />Attention à ne pas modifier les entêtes de colonnes.
                            <br />Pour supprimer un contact, il suffit de mettre "oui" dans la colonne C.
                        </v-alert>
                    </v-col>
                    <v-col cols="4" class="pa-2 pr-2 topline">
                        
                    </v-col>
                    <v-col cols="8" class="pa-2 pr-2 topline">
                        <v-alert outlined type="success" prominent border="left">
                            Pour remplacer un contact par un autre il faut mettre son identifiant dans la colonne "B".
                            <br />Une fois le fichier modifié, vous pouvez l'importer en cliquant sur le bouton "Injecter / modifier des contacts".
                        </v-alert>
                    </v-col>
                    <v-col cols="4" class="pa-2 pr-2 topline">
                        
                    </v-col>
                    <v-col cols="8" class="pa-2 pr-2 topline">

                    </v-col>
                    
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import dateLocale from '../services/dateLocale';
import { cacheGetters, cacheMutations } from "../store/cache.module"

export default {
    name: 'states',
    props: [],
    data: function () {
        return {
            saveProgress: false,         // Enregistrement en cours...
            search: '',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            headers: [
            { text: 'Nom',       align: 'left',  value: 'ctt_middlename'},
            { text: 'Société',   align: 'left',  value: 'ctt_company_name'},
            { text: 'Etat',      align: 'left',  value: 'ctt_sta_id'},
            { text: 'Type',      align: 'left',  value: 'ctt_typ_id'},
            { text: 'Téléphone', align: 'left',  value: 'ctt_phone'},
            { text: 'Email',     align: 'right', value: 'ctt_email' },
            { text: 'Maj',       align: 'right', value: 'ctt_updated_at' },
            { text: 'Conv.',     align: 'right', value: 'tcv_total' },
            { text: 'Modifier',  align: 'right', value: 'ctt_id' }
            ],
            items: [],
            locDateFormat: dateLocale,
            enableAdd: true,
            modalEvent : false,
            modalUpload: false,
            cacheTab: this.$storage.localStorage.get( this.$APP_COD + "_cache" ),
            form: { 
                file_contact: null, file_contact_name: '', file_contact_source: '',
                ctt_typ_id: 'CTT01'
            },
            withTrashed: false,
            modalHelp: false,
            tuto : {
                zip: require(  '../assets/contact_list.png'),
                edit: require( '../assets/contact_ecxel.png'),
                assoc: require('../assets/layer_assoc.jpg')
            }
        }
    },
    computed: {
        pages () {
            if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null ) return 0
            return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
        },
        validUplodContact(){
            if( this.form.file_contact_name.length > 0 ){
                return true
            } else {
                return false
            }
        }
    },
    mounted: function (){
        this.search = cacheGetters.getSearchBarItem('contacts') || ''

        this.getContact()
    },
    methods: {
        getContact(){
            return new Promise( (resolve, reject) => {
                let options = '?per_page=false&extended=withcountconvention'
                if( this.withTrashed ){
                    options = '?per_page=false&extended=withcountconvention,withtrashed'
                }
                this.$http.get( '/contacts/' + options ).then( (response) => {
                    if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                        this.items = response.data.data
                    }
                    resolve('resolved')
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
        getStates(){
            this.items = []
            
        },
        handlePage(index){
            this.pagination.limit = this.pagination.rowsPerPage * (index - 1)
            //this.pagination.page  = (index - 1)
        },
        downloadContact(){
            let options = '?per_page=false'
            if( this.withTrashed ){
                options = '?per_page=false&extended=true,withtrashed'
            }
            this.$http.customRequest({ method: 'get', url: '/report/contact/' + options, responseType: 'blob' } )
            .then( (response) => {
                this.$download(response.data, "rapport.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
            })
        },
        getFile(file, scope){
            if( file !== undefined && this.form['file_' + scope + '_name'].length == 0 ){
                //let nameTab = file.name.split(".")
                //this.form['file_' + scope + '_name'] = nameTab[0]
                this.form['file_' + scope + '_name'] = file.name
            } else {
                this.form['file_' + scope + '_name'] = ''
            }
        },
        sendContactFile(scope) {
            // Enregistrement du formulaire
            this.saveProgress = true
            var formFile = new FormData()
            for (var prop in this.form) {
                if( prop == scope ){
                    formFile.append(prop, JSON.stringify( this.form[prop] ))
                } else {
                    formFile.append(prop, this.form[prop])
                }
            }
            if( this.form['file_' + scope] ) {
                formFile.append('file_' + scope, this.form['file_' + scope], this.form['file_' + scope].name)
            }
            this.$http.post( '/contacts/upload/', formFile )
            .then( (response) => {
                this.$root.$toast({ color: 'success', text: 'Données enregistrée !' })
                this.saveProgress = false
                this.modalUpload  = false
                for( let prop in response.data ){
                    if( Array.isArray( response.data[prop].error ) ){
                        this.processInfo = response.data[prop].error
                    }
                }
            }).catch( (error) => {
                this.$root.$toast({ text: 'Erreur lors de l\'enregistrement !', error: error })
                this.saveProgress = false
                this.modalUpload  = false
            })

        },
        formatPhoneNumber(number){
            let nonInt      = /\D/g
            let allNumbers  = /.*(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})/
            let formatStyle = "0$1 $2 $3 $4 $5"
            if( number && number.length > 3 ){
                return number.replace(nonInt, '').replace(allNumbers, formatStyle)
            } else {
                return ''
            }
            //if( phone !== null && phone !== undefined && phone.length < 10 && phone.length > 8 && phone.substring(0, 1) !== 0 ){
            //    return '0' + phone
            //}
        },
        saveSearchToCache(){
            cacheMutations.setSearchBarItem('contacts', this.search)
        },
        getCacheType: cacheGetters.getTypes,
        getCacheState: cacheGetters.getStates
    },
    components: {
        
    }
}
</script>